import { useCallback, useMemo } from "react";
import { queryCache, useMutation } from "react-query";
import { createWrapUpNote } from "../../../api/services";

export const useSaveWrapUpNote = (accountNumber: string | number) => {
  const startTime = useMemo(() => Date.now(), []);
  const [mutate, { status, error }] = useMutation(createWrapUpNote, {
    onSuccess: async () => {
      await Promise.all([
        queryCache.invalidateQueries([
          "accounts/activities",
          { accountNumber },
        ]),
      ]);
    },
  });

  const saveWrapUpNote = useCallback(
    async (formData: Record<string, any>) => {
      return await mutate({
        accountNumber,
        details: formData,
        startTime,
      });
    },
    [mutate, accountNumber, startTime],
  );

  return {
    startTime,
    saveWrapUpNote,
    status,
    error,
  };
};
